import Head from 'next/head'

import { APP_ENV } from 'config/constants'

const NoindexRemoval = (props) => {
  return (
    <>
      <Head>
        {/* remove noindex only in prod mode */}
        {APP_ENV === 'prod' && <meta key="noindex" />}
      </Head>
    </>
  )
}

export default NoindexRemoval
